import React from 'react';
import ReactDOM from 'react-dom';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import TagManager from 'react-gtm-module';
import App from './App';
import './config/axiosClient';
import { GlobalStyles, theme } from '@bpba/ui-components';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

// El popup del DateInput (react-date-picker) renderea con z-index: 1 por
// default, suficientemente bajo como para que cards con stacking context
// (ej: TurnoExitoCard al lado del form de Contacto) lo tapen. Lo elevamos
// a un valor alto que vive por encima de la UI del step pero debajo de
// modales/overlays globales (que usan 1000+ en @bpba/ui-components).
const DatePickerPopupFix = createGlobalStyle`
  .react-date-picker__calendar {
    z-index: 500 !important;
  }
`;

if (process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY) {
  TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY });
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <DatePickerPopupFix />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
